<script lang="ts" module>
  import Layout from '@/layouts/default.svelte';
  export const layout = Layout;
</script>

<script lang="ts">
  import type { Click } from '@/stores/clicks';
  import { onMount } from 'svelte';
  import {
    startCable,
    stopCable,
    currentItems,
    currentTotal,
  } from '@/stores/clicks';

  import PageTitle from '@/components/PageTitle.svelte';
  import ClickButton from '@/components/ClickButton.svelte';
  import ClickList from '@/components/ClickList.svelte';

  const { items, total }: { items: Click[]; total: number } = $props();

  // Keep the store in sync with props when navigating between pages
  $effect(() => {
    if (items) currentItems.set(items);
    if (total) currentTotal.set(total);
  });

  onMount(() => {
    startCable();

    return () => {
      stopCable();
    };
  });
</script>

<div class="lg:mr-64">
  <PageTitle>Hello, Templatus!</PageTitle>

  <p class="mt-6 max-w-4xl text-base lg:text-xl">
    Templatus is an opinionated template for web applications with
    <b>Ruby on Rails</b> and <b>Inertia.js</b> using <b>Svelte.js</b>
  </p>
</div>

<ClickButton
  class="mt-5 w-full lg:absolute lg:-top-5 lg:-right-10 lg:mt-0 lg:w-56 lg:rounded-sm lg:bg-linear-to-br lg:from-slate-100 lg:to-white lg:p-3 lg:shadow-sm"
  count={$currentTotal}
/>

{#if $currentItems.length}
  <h2
    class="text-rails-dark mt-20 text-center text-xl font-medium tracking-wide uppercase sm:text-left"
  >
    Latest clicks
  </h2>

  <ClickList clicks={$currentItems.slice(0, 5)} />
{/if}
